export default __webpack_public_path__ + "static/media/Jerkin of the Furious Swipe.6e66fa20.jpg";